import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import MobileNav from "./MobileNav";

export default function AppShell({ title, children, pendingCount = 0, rightTopContent }) {
  const [isMobileShell, setIsMobileShell] = useState(false);

  useEffect(() => {
    const computeIsMobile = () => {
      const windowWidth = window.innerWidth || Number.MAX_SAFE_INTEGER;
      const screenWidth = window.screen?.width || Number.MAX_SAFE_INTEGER;
      const visualViewportWidth = window.visualViewport?.width || Number.MAX_SAFE_INTEGER;
      setIsMobileShell(Math.min(windowWidth, screenWidth, visualViewportWidth) <= 767);
    };

    computeIsMobile();
    window.addEventListener("resize", computeIsMobile);
    window.visualViewport?.addEventListener("resize", computeIsMobile);
    return () => {
      window.removeEventListener("resize", computeIsMobile);
      window.visualViewport?.removeEventListener("resize", computeIsMobile);
    };
  }, []);

  return (
    <div className="app-shell page-enter">
      {!isMobileShell ? <Sidebar pendingCount={pendingCount} /> : null}
      <main className="main-pane">
        <TopBar title={title} rightContent={rightTopContent} />
        <div className="page-content">{children}</div>
      </main>
      {isMobileShell ? <MobileNav /> : null}
    </div>
  );
}
